export default __webpack_public_path__ + "static/media/white_logo.d6061973.png";